import { API } from "aws-amplify";
import { getAmenityReservation } from "~/graphql/queries";
import * as APITypes from "~/API";
import { LoaderData } from "~/types";

export const EMPTY_RESERVATION: APITypes.AmenityReservation = {
  id: "",
  amenityID: "",
  tenantID: "",
  startDate: "",
  endDate: "",
  __typename: "AmenityReservation",
  createdAt: "",
  updatedAt: "",
  ownerID: "",
  ownerType: APITypes.OwnerType.User,
  _version: 0,
  _lastChangedAt: 0,
};

export const getReservationData = async (
  reservationID: string
): Promise<LoaderData<APITypes.AmenityReservation>> => {
  try {
    const response = (await API.graphql({
      query: getAmenityReservation,
      variables: { id: reservationID },
    })) as { data?: APITypes.GetAmenityReservationQuery };

    if (!response.data?.getAmenityReservation) {
      throw new Error("Reservation not found");
    }

    return {
      success: true,
      data: response.data.getAmenityReservation || EMPTY_RESERVATION,
    };
  } catch (error) {
    console.error("Error fetching reservation details:", error);
    return {
      success: false,
      data: EMPTY_RESERVATION,
      error,
    };
  }
};
